export default "__VITE_ASSET__DZtpTEsz__"